import _typeof from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/typeof";
import _objectSpread from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t["return"] || t["return"]();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _regeneratorRuntime() {
  "use strict";

  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */
  _regeneratorRuntime = function _regeneratorRuntime() {
    return e;
  };
  var t,
    e = {},
    r = Object.prototype,
    n = r.hasOwnProperty,
    o = Object.defineProperty || function (t, e, r) {
      t[e] = r.value;
    },
    i = "function" == typeof Symbol ? Symbol : {},
    a = i.iterator || "@iterator",
    c = i.asyncIterator || "@asyncIterator",
    u = i.toStringTag || "@toStringTag";
  function define(t, e, r) {
    return Object.defineProperty(t, e, {
      value: r,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), t[e];
  }
  try {
    define({}, "");
  } catch (t) {
    define = function define(t, e, r) {
      return t[e] = r;
    };
  }
  function wrap(t, e, r, n) {
    var i = e && e.prototype instanceof Generator ? e : Generator,
      a = Object.create(i.prototype),
      c = new Context(n || []);
    return o(a, "_invoke", {
      value: makeInvokeMethod(t, r, c)
    }), a;
  }
  function tryCatch(t, e, r) {
    try {
      return {
        type: "normal",
        arg: t.call(e, r)
      };
    } catch (t) {
      return {
        type: "throw",
        arg: t
      };
    }
  }
  e.wrap = wrap;
  var h = "suspendedStart",
    l = "suspendedYield",
    f = "executing",
    s = "completed",
    y = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  var p = {};
  define(p, a, function () {
    return this;
  });
  var d = Object.getPrototypeOf,
    v = d && d(d(values([])));
  v && v !== r && n.call(v, a) && (p = v);
  var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
  function defineIteratorMethods(t) {
    ["next", "throw", "return"].forEach(function (e) {
      define(t, e, function (t) {
        return this._invoke(e, t);
      });
    });
  }
  function AsyncIterator(t, e) {
    function invoke(r, o, i, a) {
      var c = tryCatch(t[r], t, o);
      if ("throw" !== c.type) {
        var u = c.arg,
          h = u.value;
        return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) {
          invoke("next", t, i, a);
        }, function (t) {
          invoke("throw", t, i, a);
        }) : e.resolve(h).then(function (t) {
          u.value = t, i(u);
        }, function (t) {
          return invoke("throw", t, i, a);
        });
      }
      a(c.arg);
    }
    var r;
    o(this, "_invoke", {
      value: function value(t, n) {
        function callInvokeWithMethodAndArg() {
          return new e(function (e, r) {
            invoke(t, n, e, r);
          });
        }
        return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      }
    });
  }
  function makeInvokeMethod(e, r, n) {
    var o = h;
    return function (i, a) {
      if (o === f) throw Error("Generator is already running");
      if (o === s) {
        if ("throw" === i) throw a;
        return {
          value: t,
          done: !0
        };
      }
      for (n.method = i, n.arg = a;;) {
        var c = n.delegate;
        if (c) {
          var u = maybeInvokeDelegate(c, n);
          if (u) {
            if (u === y) continue;
            return u;
          }
        }
        if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) {
          if (o === h) throw o = s, n.arg;
          n.dispatchException(n.arg);
        } else "return" === n.method && n.abrupt("return", n.arg);
        o = f;
        var p = tryCatch(e, r, n);
        if ("normal" === p.type) {
          if (o = n.done ? s : l, p.arg === y) continue;
          return {
            value: p.arg,
            done: n.done
          };
        }
        "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
      }
    };
  }
  function maybeInvokeDelegate(e, r) {
    var n = r.method,
      o = e.iterator[n];
    if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
    var i = tryCatch(o, e.iterator, r.arg);
    if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
    var a = i.arg;
    return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
  }
  function pushTryEntry(t) {
    var e = {
      tryLoc: t[0]
    };
    1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
  }
  function resetTryEntry(t) {
    var e = t.completion || {};
    e.type = "normal", delete e.arg, t.completion = e;
  }
  function Context(t) {
    this.tryEntries = [{
      tryLoc: "root"
    }], t.forEach(pushTryEntry, this), this.reset(!0);
  }
  function values(e) {
    if (e || "" === e) {
      var r = e[a];
      if (r) return r.call(e);
      if ("function" == typeof e.next) return e;
      if (!isNaN(e.length)) {
        var o = -1,
          i = function next() {
            for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
            return next.value = t, next.done = !0, next;
          };
        return i.next = i;
      }
    }
    throw new TypeError(_typeof(e) + " is not iterable");
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
    value: GeneratorFunctionPrototype,
    configurable: !0
  }), o(GeneratorFunctionPrototype, "constructor", {
    value: GeneratorFunction,
    configurable: !0
  }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) {
    var e = "function" == typeof t && t.constructor;
    return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
  }, e.mark = function (t) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
  }, e.awrap = function (t) {
    return {
      __await: t
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () {
    return this;
  }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) {
    void 0 === i && (i = Promise);
    var a = new AsyncIterator(wrap(t, r, n, o), i);
    return e.isGeneratorFunction(r) ? a : a.next().then(function (t) {
      return t.done ? t.value : a.next();
    });
  }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () {
    return this;
  }), define(g, "toString", function () {
    return "[object Generator]";
  }), e.keys = function (t) {
    var e = Object(t),
      r = [];
    for (var n in e) r.push(n);
    return r.reverse(), function next() {
      for (; r.length;) {
        var t = r.pop();
        if (t in e) return next.value = t, next.done = !1, next;
      }
      return next.done = !0, next;
    };
  }, e.values = values, Context.prototype = {
    constructor: Context,
    reset: function reset(e) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
    },
    stop: function stop() {
      this.done = !0;
      var t = this.tryEntries[0].completion;
      if ("throw" === t.type) throw t.arg;
      return this.rval;
    },
    dispatchException: function dispatchException(e) {
      if (this.done) throw e;
      var r = this;
      function handle(n, o) {
        return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
      }
      for (var o = this.tryEntries.length - 1; o >= 0; --o) {
        var i = this.tryEntries[o],
          a = i.completion;
        if ("root" === i.tryLoc) return handle("end");
        if (i.tryLoc <= this.prev) {
          var c = n.call(i, "catchLoc"),
            u = n.call(i, "finallyLoc");
          if (c && u) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          } else if (c) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
          } else {
            if (!u) throw Error("try statement without catch or finally");
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          }
        }
      }
    },
    abrupt: function abrupt(t, e) {
      for (var r = this.tryEntries.length - 1; r >= 0; --r) {
        var o = this.tryEntries[r];
        if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
          var i = o;
          break;
        }
      }
      i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
      var a = i ? i.completion : {};
      return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
    },
    complete: function complete(t, e) {
      if ("throw" === t.type) throw t.arg;
      return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
    },
    finish: function finish(t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
      }
    },
    "catch": function _catch(t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.tryLoc === t) {
          var n = r.completion;
          if ("throw" === n.type) {
            var o = n.arg;
            resetTryEntry(r);
          }
          return o;
        }
      }
      throw Error("illegal catch attempt");
    },
    delegateYield: function delegateYield(e, r, n) {
      return this.delegate = {
        iterator: values(e),
        resultName: r,
        nextLoc: n
      }, "next" === this.method && (this.arg = t), y;
    }
  }, e;
} /*@通用-数据层*/
import { get_agency_list as _get_agency_list, get_agency_list_all, get_company_list as _get_company_list, get_isp_dict as _get_isp_dict, all_company_update } from "../../services/Company/companyS";
import { create_fml_device as _create_fml_device, create_fullmesh_link as _create_fullmesh_link, delete_fullmesh_link as _delete_fullmesh_link, get_fml_agency_device as _get_fml_agency_device, get_fullmesh_link as _get_fullmesh_link, update_fullmesh_link as _update_fullmesh_link, get_fml_device as _get_fml_device, update_fml_device as _update_fml_device, update_fml_isp as _update_fml_isp, create_fml_isp as _create_fml_isp, get_fml_isp as _get_fml_isp, delete_fml_isp as _delete_fml_isp, get_fml_static_link as _get_fml_static_link, update_fml_static_link as _update_fml_static_link, create_fml_static_link as _create_fml_static_link, delete_fml_static_link as _delete_fml_static_link, create_fml_all as _create_fml_all, batch_update_fullmesh_link as _batch_update_fullmesh_link, get_deleted_fullmesh_link as _get_deleted_fullmesh_link } from "../../services/BI/BI0801S";
import { BossMessage } from "../../components/Common/BossMessages";
export default {
  namespace: "bi0801Info",
  state: {
    companyList: [],
    fullMeshList: [],
    editRecord: {},
    editId: "",
    current: 0,
    agencyListCenter: [],
    agencyListEdge: [],
    fmlAgencyDeviceList: [],
    fmlDeviceList: [],
    ispList: [],
    ispDictList: [],
    staticLinkList: [],
    staticLinkAgencyList: [],
    initPayload: {}
  },
  effects: {
    get_agency_list: function get_agency_list(_ref, _ref2) {
      var payload = _ref.payload;
      var call = _ref2.call,
        put = _ref2.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return call(_get_agency_list, payload);
            case 2:
              backData = _context.sent;
              if (!backData.result) {
                _context.next = 11;
                break;
              }
              if (!(payload.type === "CSTEP")) {
                _context.next = 9;
                break;
              }
              _context.next = 7;
              return put({
                type: "update",
                payload: {
                  agencyListCenter: backData && backData.result && Array.isArray(backData.result) ? backData.result : []
                }
              });
            case 7:
              _context.next = 11;
              break;
            case 9:
              _context.next = 11;
              return put({
                type: "update",
                payload: {
                  agencyListEdge: backData && backData.result && Array.isArray(backData.result) ? backData.result : []
                }
              });
            case 11:
            case "end":
              return _context.stop();
          }
        }, _callee);
      })();
    },
    get_fml_agency_device: function get_fml_agency_device(_ref3, _ref4) {
      var payload = _ref3.payload;
      var call = _ref4.call,
        put = _ref4.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return call(_get_fml_agency_device, payload);
            case 2:
              backData = _context2.sent;
              _context2.next = 5;
              return put({
                type: 'update',
                payload: {
                  fmlAgencyDeviceList: backData && backData.result && Array.isArray(backData.result) ? backData.result : []
                }
              });
            case 5:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      })();
    },
    get_fml_device: function get_fml_device(_ref5, _ref6) {
      var payload = _ref5.payload;
      var call = _ref6.call,
        put = _ref6.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return call(_get_fml_device, payload);
            case 2:
              backData = _context3.sent;
              _context3.next = 5;
              return put({
                type: 'update',
                payload: {
                  fmlDeviceList: backData && backData.result && Array.isArray(backData.result) ? backData.result : []
                }
              });
            case 5:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      })();
    },
    get_company_list: function get_company_list(_ref7, _ref8) {
      var payload = _ref7.payload;
      var call = _ref8.call,
        put = _ref8.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return call(_get_company_list, payload);
            case 2:
              backData = _context4.sent;
              _context4.next = 5;
              return put({
                type: "update",
                payload: {
                  companyList: backData && backData.result && Array.isArray(backData.result) ? backData.result : []
                }
              });
            case 5:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      })();
    },
    get_fullmesh_link: function get_fullmesh_link(_ref9, _ref10) {
      var payload = _ref9.payload;
      var call = _ref10.call,
        put = _ref10.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return call(_get_fullmesh_link, payload);
            case 2:
              backData = _context5.sent;
              _context5.next = 5;
              return put({
                type: "update",
                payload: {
                  fullMeshList: backData && backData.result && Array.isArray(backData.result) ? backData.result : [],
                  initPayload: payload
                }
              });
            case 5:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      })();
    },
    get_isp_dict: function get_isp_dict(_ref11, _ref12) {
      var payload = _ref11.payload;
      var call = _ref12.call,
        put = _ref12.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return call(_get_isp_dict, payload);
            case 2:
              backData = _context6.sent;
              _context6.next = 5;
              return put({
                type: "update",
                payload: {
                  ispDictList: backData && backData.result && Array.isArray(backData.result) ? backData.result : []
                }
              });
            case 5:
            case "end":
              return _context6.stop();
          }
        }, _callee6);
      })();
    },
    get_fml_isp: function get_fml_isp(_ref13, _ref14) {
      var payload = _ref13.payload;
      var call = _ref14.call,
        put = _ref14.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              _context7.next = 2;
              return call(_get_fml_isp, payload);
            case 2:
              backData = _context7.sent;
              _context7.next = 5;
              return put({
                type: "update",
                payload: {
                  ispList: backData && backData.result && Array.isArray(backData.result) ? backData.result : []
                }
              });
            case 5:
            case "end":
              return _context7.stop();
          }
        }, _callee7);
      })();
    },
    create_fullmesh_link: function create_fullmesh_link(_ref15, _ref16) {
      var payload = _ref15.payload;
      var call = _ref16.call,
        put = _ref16.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              _context8.next = 2;
              return call(_create_fullmesh_link, payload.update);
            case 2:
              backData = _context8.sent;
              if (backData.success) {
                _context8.next = 7;
                break;
              }
              BossMessage(false, "创建失败" + backData.result);
              _context8.next = 12;
              break;
            case 7:
              BossMessage(true, "创建成功");
              _context8.next = 10;
              return call(all_company_update, {
                company_id: payload.update.company_id
              });
            case 10:
              _context8.next = 12;
              return put({
                type: "get_fullmesh_link",
                payload: payload.init
              });
            case 12:
            case "end":
              return _context8.stop();
          }
        }, _callee8);
      })();
    },
    update_fullmesh_link: function update_fullmesh_link(_ref17, _ref18) {
      var payload = _ref17.payload;
      var call = _ref18.call,
        put = _ref18.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee9() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              _context9.next = 2;
              return call(_update_fullmesh_link, payload.update);
            case 2:
              backData = _context9.sent;
              if (backData.success) {
                _context9.next = 7;
                break;
              }
              BossMessage(false, "Editing failed" + backData.result);
              _context9.next = 12;
              break;
            case 7:
              BossMessage(true, "Successfully edited");
              _context9.next = 10;
              return call(all_company_update, {
                company_id: payload.update.company_id
              });
            case 10:
              _context9.next = 12;
              return put({
                type: "get_fullmesh_link",
                payload: payload.init
              });
            case 12:
            case "end":
              return _context9.stop();
          }
        }, _callee9);
      })();
    },
    delete_fullmesh_link: function delete_fullmesh_link(_ref19, _ref20) {
      var payload = _ref19.payload;
      var call = _ref20.call,
        put = _ref20.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee10() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              _context10.next = 2;
              return call(_delete_fullmesh_link, payload["delete"]);
            case 2:
              backData = _context10.sent;
              if (backData.success) {
                _context10.next = 7;
                break;
              }
              BossMessage(false, "删除失败:" + backData.result);
              _context10.next = 12;
              break;
            case 7:
              BossMessage(true, "删除成功");
              _context10.next = 10;
              return call(all_company_update, {
                company_id: payload.init.company_id
              });
            case 10:
              _context10.next = 12;
              return put({
                type: "get_fullmesh_link",
                payload: payload.init
              });
            case 12:
            case "end":
              return _context10.stop();
          }
        }, _callee10);
      })();
    },
    create_fml_device: function create_fml_device(_ref21, _ref22) {
      var payload = _ref21.payload;
      var call = _ref22.call,
        put = _ref22.put,
        select = _ref22.select;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee11() {
        var values, fmlAgencyDeviceList, key, value, agency_id, _iterator, _step, agency, _agency_id, _iterator2, _step2, _agency, backData, initPayload;
        return _regeneratorRuntime().wrap(function _callee11$(_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              values = payload.update.data;
              _context11.next = 3;
              return select(function (state) {
                return state.bi0801Info.fmlAgencyDeviceList;
              });
            case 3:
              fmlAgencyDeviceList = _context11.sent;
              for (key in values) {
                value = values[key];
                if (key.indexOf('main') > -1) {
                  agency_id = key.replace(/^main/, '');
                  _iterator = _createForOfIteratorHelper(fmlAgencyDeviceList);
                  try {
                    for (_iterator.s(); !(_step = _iterator.n()).done;) {
                      agency = _step.value;
                      if (agency.agency_id.toString() === agency_id) {
                        agency.main = value;
                      }
                    }
                  } catch (err) {
                    _iterator.e(err);
                  } finally {
                    _iterator.f();
                  }
                }
                if (key.indexOf('backup') > -1) {
                  _agency_id = key.replace(/^backup/, '');
                  _iterator2 = _createForOfIteratorHelper(fmlAgencyDeviceList);
                  try {
                    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                      _agency = _step2.value;
                      if (_agency.agency_id.toString() === _agency_id) {
                        _agency.backup = value;
                      }
                    }
                  } catch (err) {
                    _iterator2.e(err);
                  } finally {
                    _iterator2.f();
                  }
                }
              }
              payload.update.data = fmlAgencyDeviceList;
              _context11.next = 8;
              return call(_create_fml_device, payload.update);
            case 8:
              backData = _context11.sent;
              _context11.next = 11;
              return select(function (state) {
                return state.bi0801Info.initPayload;
              });
            case 11:
              initPayload = _context11.sent;
              if (backData.success) {
                _context11.next = 16;
                break;
              }
              BossMessage(false, "编辑失败:" + backData.result);
              _context11.next = 21;
              break;
            case 16:
              BossMessage(true, "编辑成功");
              _context11.next = 19;
              return call(all_company_update, {
                company_id: payload.init.company_id
              });
            case 19:
              _context11.next = 21;
              return put({
                type: "get_fullmesh_link",
                payload: initPayload
              });
            case 21:
            case "end":
              return _context11.stop();
          }
        }, _callee11);
      })();
    },
    update_fml_device: function update_fml_device(_ref23, _ref24) {
      var payload = _ref23.payload;
      var call = _ref24.call,
        put = _ref24.put,
        select = _ref24.select;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee12() {
        var backData, fmlDeviceList, _iterator3, _step3, device;
        return _regeneratorRuntime().wrap(function _callee12$(_context12) {
          while (1) switch (_context12.prev = _context12.next) {
            case 0:
              _context12.next = 2;
              return call(_update_fml_device, payload.update);
            case 2:
              backData = _context12.sent;
              if (!backData.success) {
                _context12.next = 13;
                break;
              }
              _context12.next = 6;
              return select(function (state) {
                return state.bi0801Info.fmlDeviceList;
              });
            case 6:
              fmlDeviceList = _context12.sent;
              _iterator3 = _createForOfIteratorHelper(fmlDeviceList);
              try {
                for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
                  device = _step3.value;
                  if (device.device_id === payload.update.device_id) {
                    device.isp_type = payload.update.isp_type;
                  }
                }
              } catch (err) {
                _iterator3.e(err);
              } finally {
                _iterator3.f();
              }
              _context12.next = 11;
              return put({
                type: "update",
                payload: {
                  fmlDeviceList: fmlDeviceList
                }
              });
            case 11:
              _context12.next = 13;
              return call(all_company_update, {
                company_id: payload.init.company_id
              });
            case 13:
            case "end":
              return _context12.stop();
          }
        }, _callee12);
      })();
    },
    update_fml_isp: function update_fml_isp(_ref25, _ref26) {
      var payload = _ref25.payload;
      var call = _ref26.call,
        put = _ref26.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee13() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee13$(_context13) {
          while (1) switch (_context13.prev = _context13.next) {
            case 0:
              _context13.next = 2;
              return call(_update_fml_isp, payload.update);
            case 2:
              backData = _context13.sent;
              if (backData.success) {
                _context13.next = 7;
                break;
              }
              BossMessage(false, "Editing failed" + backData.result);
              _context13.next = 12;
              break;
            case 7:
              BossMessage(true, "Successfully edited");
              _context13.next = 10;
              return call(all_company_update, {
                company_id: payload.initcompany.company_id
              });
            case 10:
              _context13.next = 12;
              return put({
                type: "get_fml_isp",
                payload: payload.init
              });
            case 12:
            case "end":
              return _context13.stop();
          }
        }, _callee13);
      })();
    },
    create_fml_isp: function create_fml_isp(_ref27, _ref28) {
      var payload = _ref27.payload;
      var call = _ref28.call,
        put = _ref28.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee14() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee14$(_context14) {
          while (1) switch (_context14.prev = _context14.next) {
            case 0:
              _context14.next = 2;
              return call(_create_fml_isp, payload.update);
            case 2:
              backData = _context14.sent;
              if (backData.success) {
                _context14.next = 7;
                break;
              }
              BossMessage(false, "Add failed" + backData.result);
              _context14.next = 12;
              break;
            case 7:
              BossMessage(true, "Successfully added");
              _context14.next = 10;
              return call(all_company_update, {
                company_id: payload.initcompany.company_id
              });
            case 10:
              _context14.next = 12;
              return put({
                type: "get_fml_isp",
                payload: payload.init
              });
            case 12:
            case "end":
              return _context14.stop();
          }
        }, _callee14);
      })();
    },
    delete_fml_isp: function delete_fml_isp(_ref29, _ref30) {
      var payload = _ref29.payload;
      var call = _ref30.call,
        put = _ref30.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee15() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee15$(_context15) {
          while (1) switch (_context15.prev = _context15.next) {
            case 0:
              _context15.next = 2;
              return call(_delete_fml_isp, payload["delete"]);
            case 2:
              backData = _context15.sent;
              if (backData.success) {
                _context15.next = 7;
                break;
              }
              BossMessage(false, "删除失败:" + backData.result);
              _context15.next = 12;
              break;
            case 7:
              BossMessage(true, "删除成功");
              _context15.next = 10;
              return call(all_company_update, {
                company_id: payload.initcompany.company_id
              });
            case 10:
              _context15.next = 12;
              return put({
                type: "get_fml_isp",
                payload: payload.init
              });
            case 12:
            case "end":
              return _context15.stop();
          }
        }, _callee15);
      })();
    },
    get_fml_static_link: function get_fml_static_link(_ref31, _ref32) {
      var payload = _ref31.payload;
      var call = _ref32.call,
        put = _ref32.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee16() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee16$(_context16) {
          while (1) switch (_context16.prev = _context16.next) {
            case 0:
              _context16.next = 2;
              return call(_get_fml_static_link, payload);
            case 2:
              backData = _context16.sent;
              _context16.next = 5;
              return put({
                type: "update",
                payload: {
                  staticLinkList: backData && backData.result && Array.isArray(backData.result) ? backData.result : []
                }
              });
            case 5:
            case "end":
              return _context16.stop();
          }
        }, _callee16);
      })();
    },
    update_fml_static_link: function update_fml_static_link(_ref33, _ref34) {
      var payload = _ref33.payload;
      var call = _ref34.call,
        put = _ref34.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee17() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee17$(_context17) {
          while (1) switch (_context17.prev = _context17.next) {
            case 0:
              _context17.next = 2;
              return call(_update_fml_static_link, payload.update);
            case 2:
              backData = _context17.sent;
              if (backData.success) {
                _context17.next = 7;
                break;
              }
              BossMessage(false, "Editing failed" + backData.result);
              _context17.next = 12;
              break;
            case 7:
              BossMessage(true, "Successfully edited");
              _context17.next = 10;
              return call(all_company_update, {
                company_id: payload.initcompany.company_id
              });
            case 10:
              _context17.next = 12;
              return put({
                type: "get_fml_static_link",
                payload: payload.init
              });
            case 12:
            case "end":
              return _context17.stop();
          }
        }, _callee17);
      })();
    },
    create_fml_static_link: function create_fml_static_link(_ref35, _ref36) {
      var payload = _ref35.payload;
      var call = _ref36.call,
        put = _ref36.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee18() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee18$(_context18) {
          while (1) switch (_context18.prev = _context18.next) {
            case 0:
              _context18.next = 2;
              return call(_create_fml_static_link, payload.update);
            case 2:
              backData = _context18.sent;
              if (backData.success) {
                _context18.next = 7;
                break;
              }
              BossMessage(false, "Add failed" + backData.result);
              _context18.next = 12;
              break;
            case 7:
              BossMessage(true, "Successfully added");
              _context18.next = 10;
              return call(all_company_update, {
                company_id: payload.initcompany.company_id
              });
            case 10:
              _context18.next = 12;
              return put({
                type: "get_fml_static_link",
                payload: payload.init
              });
            case 12:
            case "end":
              return _context18.stop();
          }
        }, _callee18);
      })();
    },
    delete_fml_static_link: function delete_fml_static_link(_ref37, _ref38) {
      var payload = _ref37.payload;
      var call = _ref38.call,
        put = _ref38.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee19() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee19$(_context19) {
          while (1) switch (_context19.prev = _context19.next) {
            case 0:
              _context19.next = 2;
              return call(_delete_fml_static_link, payload["delete"]);
            case 2:
              backData = _context19.sent;
              if (backData.success) {
                _context19.next = 7;
                break;
              }
              BossMessage(false, "删除失败:" + backData.result);
              _context19.next = 12;
              break;
            case 7:
              BossMessage(true, "删除成功");
              _context19.next = 10;
              return call(all_company_update, {
                company_id: payload.initcompany.company_id
              });
            case 10:
              _context19.next = 12;
              return put({
                type: "get_fml_static_link",
                payload: payload.init
              });
            case 12:
            case "end":
              return _context19.stop();
          }
        }, _callee19);
      })();
    },
    get_agency_list_static: function get_agency_list_static(_ref39, _ref40) {
      var payload = _ref39.payload;
      var call = _ref40.call,
        put = _ref40.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee20() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee20$(_context20) {
          while (1) switch (_context20.prev = _context20.next) {
            case 0:
              _context20.next = 2;
              return call(get_agency_list_all, payload);
            case 2:
              backData = _context20.sent;
              _context20.next = 5;
              return put({
                type: "update",
                payload: {
                  staticLinkAgencyList: backData && backData.result && Array.isArray(backData.result) ? backData.result : []
                }
              });
            case 5:
            case "end":
              return _context20.stop();
          }
        }, _callee20);
      })();
    },
    create_fml_all: function create_fml_all(_ref41, _ref42) {
      var payload = _ref41.payload;
      var call = _ref42.call,
        put = _ref42.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee21() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee21$(_context21) {
          while (1) switch (_context21.prev = _context21.next) {
            case 0:
              _context21.next = 2;
              return call(_create_fml_all, payload.update);
            case 2:
              backData = _context21.sent;
              if (backData.success) {
                _context21.next = 7;
                break;
              }
              BossMessage(false, "生成失败");
              _context21.next = 10;
              break;
            case 7:
              _context21.next = 9;
              return call(all_company_update, {
                company_id: payload.initcompany.company_id
              });
            case 9:
              BossMessage(true, "生成成功");
            case 10:
            case "end":
              return _context21.stop();
          }
        }, _callee21);
      })();
    },
    batch_update_fullmesh_link: function batch_update_fullmesh_link(_ref43, _ref44) {
      var payload = _ref43.payload;
      var call = _ref44.call,
        put = _ref44.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee22() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee22$(_context22) {
          while (1) switch (_context22.prev = _context22.next) {
            case 0:
              _context22.next = 2;
              return call(_batch_update_fullmesh_link, payload.update);
            case 2:
              backData = _context22.sent;
              if (backData.success) {
                _context22.next = 7;
                break;
              }
              BossMessage(false, "Editing failed" + backData.result);
              _context22.next = 10;
              break;
            case 7:
              BossMessage(true, "Successfully edited");
              _context22.next = 10;
              return put({
                type: "get_fullmesh_link",
                payload: payload.init
              });
            case 10:
            case "end":
              return _context22.stop();
          }
        }, _callee22);
      })();
    },
    get_deleted_fullmesh_link: function get_deleted_fullmesh_link(_ref45, _ref46) {
      var payload = _ref45.payload;
      var call = _ref46.call,
        put = _ref46.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee23() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee23$(_context23) {
          while (1) switch (_context23.prev = _context23.next) {
            case 0:
              _context23.next = 2;
              return call(_get_deleted_fullmesh_link, payload);
            case 2:
              backData = _context23.sent;
              _context23.next = 5;
              return put({
                type: "update",
                payload: {
                  fullMeshList: backData.result
                }
              });
            case 5:
            case "end":
              return _context23.stop();
          }
        }, _callee23);
      })();
    }
  },
  reducers: {
    update: function update(state, action) {
      return _objectSpread({}, state, action.payload);
    }
  }
};